import React from 'react';
import { ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import ReactPlayer from 'react-player'

function VideoModal(props) {
  const closeBtn = <button className="close" style={{color: "#fff"}} onClick={props.toggle}>&times;</button>;
  return (
    <>
      <ModalHeader close={closeBtn} style={{backgroundColor: "rgba(41, 107, 169, 1)", color: "#fff"}} toggle={props.toggle}>{props.content.name}</ModalHeader>
      <ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
          <ReactPlayer controls light url={props.content.link} />
        </div>
      </ModalBody>
    </>
  );
}

export default VideoModal;